import { render, staticRenderFns } from "./ResetPasswordRequest.vue?vue&type=template&id=12c15d5d"
import script from "./ResetPasswordRequest.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordRequest.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordRequest.vue?vue&type=style&index=0&id=12c15d5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports